import { render, staticRenderFns } from "./JobInfo.vue?vue&type=template&id=38470d6b&scoped=true&"
import script from "./JobInfo.vue?vue&type=script&lang=js&"
export * from "./JobInfo.vue?vue&type=script&lang=js&"
import style0 from "./JobInfo.vue?vue&type=style&index=0&id=38470d6b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38470d6b",
  null
  
)

export default component.exports